import { useState } from 'react';
import { track } from '@generated/hooks/useTrack';
import { ExternalLink, Truck } from 'lucide-react';

const SHOP = 'https://www.etsy.com/shop/StarRevue';
const PHOTOS = [
  { src: 'https://files-public.monday.com/use1/cc414d65-01fb-44f7-89ac-8a405b4af461/black%20shirt.png', alt: 'Red Hook Star-Revue T-shirt in black', pos: 'object-center' },
  { src: 'https://files-public.monday.com/use1/5b48e4b7-89d9-4a31-acd7-41e7ee62a851/IMG_4050.jpg', alt: 'Red Hook Star-Revue T-shirt in navy', pos: 'object-top' },
];
const COLORS = ['Black', 'White', 'Navy', 'Light Blue'];
const SIZES = ['S', 'M', 'L', 'XL', '2XL'];

export function Shop() {
  const [active, setActive] = useState(0);
  const photo = PHOTOS[active] ?? PHOTOS[0];
  return (
    <section>
      <div className="border-b border-foreground pb-2">
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">The Star-Revue Shop on Etsy</div>
      </div>
      <article className="mx-auto mt-8 grid max-w-5xl overflow-hidden border-2 border-foreground bg-card md:grid-cols-2">
        <div className="flex flex-col bg-muted">
          {photo && <img src={photo.src} alt={photo.alt} className={`aspect-square w-full object-cover ${photo.pos}`} />}
          <div className="flex gap-2 p-3">
            {PHOTOS.map((p, i) => (
              <button key={p.src} onClick={() => setActive(i)} aria-label={`Show photo: ${p.alt}`}
                className={`h-16 w-16 overflow-hidden border-2 ${i === active ? 'border-primary' : 'border-transparent opacity-70 hover:opacity-100'}`}>
                <img src={p.src} alt="" className={`h-full w-full object-cover ${p.pos}`} />
              </button>
            ))}
          </div>
        </div>
        <div className="flex flex-col justify-center gap-5 p-6 sm:p-10">
          <div>
            <h2 className="font-[family-name:var(--font-heading)] text-4xl font-semibold leading-tight text-[hsl(var(--brand-blue))]">The Red Hook Star-Revue T-Shirt</h2>
            <div className="mt-2 flex flex-wrap items-baseline gap-3">
              <span className="font-[family-name:var(--font-heading)] text-3xl tabular-nums">$30</span>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary"><Truck className="h-4 w-4" />Free shipping</span>
            </div>
          </div>
          <div>
            <p className="text-lg">Available in four colors.</p>
            <ul className="mt-2 flex flex-wrap gap-2">
              {COLORS.map((c) => <li key={c} className="border border-border px-3 py-1 text-sm">{c}</li>)}
            </ul>
          </div>
          <div>
            <div className="text-sm font-medium">Sizes</div>
            <ul className="mt-2 flex flex-wrap gap-2">
              {SIZES.map((s) => <li key={s} className="min-w-10 border border-border px-2 py-1 text-center text-sm">{s}</li>)}
            </ul>
          </div>
          <p className="text-sm text-muted-foreground">Visit our Etsy store to choose your color and size and complete your purchase.</p>
          <a href={SHOP} target="_blank" rel="noreferrer" onClick={() => track("etsy_click")}
            className="inline-flex min-h-12 w-fit items-center gap-2 bg-primary px-6 text-sm font-semibold text-primary-foreground hover:bg-primary/90">
            Buy on Etsy<ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </article>
    </section>
  );
}
